import Grid from "@mui/material/Grid";
import { Box, Stack } from "@mui/material";
import { LabelTemplate } from "./styles/table";
import { Employee } from "../types/processTypes";

import { BasicPostAppliedSingleValue } from "./components/basic/BasicPostApplied";
import { BasicDetail } from "./components/basic/BasicDetail";
import { BasicLanguageInaya } from "./components/basic/BasicLanguage";
import { BasicExperience } from "./components/basic/BasicExperience";
import { BasicSkillsOneLineHorz } from "./components/basic/BasicSkills";
import { BasicPassport } from "./components/basic/BasicPassport";
import { BasicFace, BasicFaceNoBorder } from "./components/basic/BasicFace";
import { BasicStand, BasicStandNoBorder } from "./components/basic/BasicStand";
import { BasicPassportScan } from "./components/basic/BasicPassportScan";
import {
  BasicHeader,
  BasicHeaderNoBorder,
} from "./components/basic/BasicHeader";
import { Company } from "../../setups/types/setupTypes";
import { BasicFooter } from "./components/basic/BasicFooter";

interface Props {
  selectedCompany: Company;
  currentEmployee: Employee;
  backgroundColor: string;
  cvTemplate: LabelTemplate;
}
function MotaTemplate({
  selectedCompany,
  currentEmployee,
  backgroundColor,
  cvTemplate,
}: Props) {
  //a08745;f2f1f0 fffcf2
  const lineTemplate = {
    ...cvTemplate,
    showCellBorders: true,
    transparentTableBackground: true,
  };
  // bodyHeight: 34,
  // headerHeight: 36,
  // labelFontSize: 14,
  // valueFontSize: 14,

  return (
    <>
      <Box id="personalData" sx={{ p: 1 }}>
        <Grid
          container
          spacing={cvTemplate.spacing}
          sx={{
            p: 1,
            backgroundColor: backgroundColor,
            background:
              "linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)),url(/motaLogo.png)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center 42%",
            backgroundSize: "85% auto",
            "& .MuiTable-root tbody tr td:nth-of-type(2), & .MuiTable-root tbody tr td:nth-of-type(3)":
              {
                textAlign: "center",
              },
            "& .MuiTable-root thead tr th:last-of-type, & .MuiTable-root tbody tr td:last-of-type":
              {
                textAlign: "right",
              },
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              height: "90%",
              mb: 1,
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeaderNoBorder
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
          <Grid
            container
            item
            xs={12}
            spacing={cvTemplate.spacing}
            justifyContent="center"
            alignItems="center"
          >
            <Grid container item xs={9}>
              {cvTemplate && currentEmployee && (
                <>
                  <Grid item xs={12}>
                    {/* <BasicReferenceOnly
                      currentEmployee={currentEmployee}
                      template={lineTemplate}
                    />

                    <BasicFullName
                      currentEmployee={currentEmployee}
                      template={lineTemplate}
                    /> */}

                    <BasicPostAppliedSingleValue
                      currentEmployee={currentEmployee}
                      template={lineTemplate}
                      showHeader={false}
                      showAgent={true}
                      showName={true}
                      showProfession={true}
                      showSalary={true}
                      showContractPeriod={true}
                      showEmployeeTelephone={true}
                    />
                  </Grid>
                </>
              )}
            </Grid>
            {/* Short Photo */}
            <Grid item xs={3}>
              {cvTemplate && currentEmployee && (
                <BasicFaceNoBorder
                  currentEmployee={currentEmployee}
                  template={{
                    ...cvTemplate,
                  }}
                />
              )}
            </Grid>
          </Grid>

          <Grid item md={7} xs={12}>
            {cvTemplate && currentEmployee && (
              <>
                <BasicDetail
                  currentEmployee={currentEmployee}
                  template={lineTemplate}
                  showHeader={true}
                  showReference={false}
                  showNationality={true}
                  showPassportNumber={false}
                  showReligion={true}
                  showDateOfBirth={true}
                  showAge={true}
                  showPlaceOfBirth={true}
                  showMaritalStatus={true}
                  showNumberOfChildren={true}
                  showWeightHeight={false}
                  showComplexion={true}
                  showEducation={true}
                  showLivingTown={true}
                  showEmployeeTelephone={false}
                  showContactName={false}
                  showContactTelephone={false}
                />
                <BasicPassport
                  currentEmployee={currentEmployee}
                  template={lineTemplate}
                  showHeader={false}
                  showPassportNumber={true}
                  showIssueDate={true}
                  showPlaceOfIssue={true}
                  showExpiryDate={true}
                />
                <BasicLanguageInaya
                  currentEmployee={currentEmployee}
                  template={lineTemplate}
                />
              </>
            )}
          </Grid>
          <Grid item md={5} xs={12}>
            {cvTemplate && currentEmployee && (
              <Stack
                spacing={cvTemplate.spacing}
                sx={{
                  alignItems: "center",
                }}
              >
                <BasicStandNoBorder
                  currentEmployee={currentEmployee}
                  template={{ ...cvTemplate }}
                />
                <BasicDetail
                  currentEmployee={currentEmployee}
                  template={lineTemplate}
                  showHeader={false}
                  showReference={false}
                  showNationality={false}
                  showPassportNumber={false}
                  showReligion={false}
                  showDateOfBirth={false}
                  showAge={false}
                  showPlaceOfBirth={false}
                  showMaritalStatus={false}
                  showNumberOfChildren={false}
                  showWeightHeight={true}
                  showComplexion={false}
                  showEducation={false}
                  showLivingTown={false}
                  showEmployeeTelephone={false}
                  showContactName={false}
                  showContactTelephone={false}
                />
              </Stack>
            )}
          </Grid>

          <Grid item xs={12}>
            {cvTemplate && currentEmployee && (
              <BasicExperience
                currentEmployee={currentEmployee}
                template={lineTemplate}
                type="basic"
              />
            )}
            {cvTemplate && currentEmployee && (
              <BasicSkillsOneLineHorz
                currentEmployee={currentEmployee}
                template={lineTemplate}
                includeIroning={true}
              />
            )}
          </Grid>
          <Grid item xs={12}>
            {cvTemplate && currentEmployee && (
              <BasicFooter
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
        </Grid>
      </Box>
      <Stack
        id="passportData"
        sx={{
          p: 1,
          pt: 1,
          backgroundColor: backgroundColor,
          minHeight: "1500px",
          background:
            "linear-gradient(0deg, rgba(255, 255, 255, 0.80), rgba(255, 255, 255, 0.80)),url(/motaLogo.png)",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center 42%",
          backgroundSize: "85% auto",
        }}
      >
        {cvTemplate.addPassportHeader && (
          <Box
            sx={{
              height: "90%",
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeader
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Box>
        )}
        {cvTemplate && currentEmployee && (
          <Box
            sx={{
              mt: 15,
            }}
          >
            <BasicPassportScan
              currentEmployee={currentEmployee}
              template={cvTemplate}
            />
          </Box>
        )}
      </Stack>
    </>
  );
}

export default MotaTemplate;
